import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { SHARED_GATEWAY_CONFIG, GatewayConfig } from '../gateway.config';

@Pipe({
  name: 'cdnPrefix',
})
export class CdnPrefixPipe implements PipeTransform {
  constructor(@Inject(SHARED_GATEWAY_CONFIG) private _config: GatewayConfig) {}

  transform(path: string): string {
    return Location.joinWithSlash(this._config.cdn, path);
  }
}
